import { Link } from "react-router-dom";
import { serviceList } from "@/mocks/services";
import SectionHeading from "./SectionHeading";

export default function RecentServices() {
  const items = serviceList.slice(0, 3);
  return (
    <section>
      <SectionHeading icon="ri-hand-heart-line" title="近期生活服务" subtitle="邻居们发布的生活服务信息" moreTo="/services" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/services/${item.id}`}
            className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
          >
            <div className="w-full h-40 bg-background-200 overflow-hidden">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 text-xs font-medium">{item.type}</span>
                <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-map-pin-line"></i>{item.district}</span>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{item.contactNote}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}